import React, { useState } from 'react';

import './content-search.css';

export const ContentSearch = ({ onSearch }) => {
    const [searchQuery, setSearchQuery] = useState('');

    const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
        onSearch(e.target.value);
    };

    return (
        <div className="content-search">
            <form>
                <div className="form-field">
                    <input 
                        type="text" 
                        placeholder="Search..." 
                        value={searchQuery} 
                        onChange={handleInputChange} 
                    />
                </div>
            </form>
        </div>
    );
};